import React from "react";
import {
  Box,
  Flex,
  Stack,
  useDisclosure,
  IconButton,
} from "@chakra-ui/core";
import Logo from "../elements/Logo";
//import { FaRegBell } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import MobileMenu from "../menus/MobileMenu";
import AddMenu from "../menus/AddMenu"
import ProfileMenu from "../menus/ProfileMenu"
import MainDashboardMenu from '../menus/MainDashboardMenu'

/** The upper most part of the dashboard (Logo, main menu ...) */

const DashboardHeader = ({ currentSection, setCurrentSection, merchantDetails }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <>
      <Box
        pos="relative"
        top="0"
        zIndex="4"
        left="0"
        right="0"
        width="100%"
        py="15px"
        bg="primary.600"
      >
        <Flex align="center" justify="center" w="100%">
          <Box maxWidth="1280px" w="100%" h="100%">
            <Flex
              size="100%"
              align="center"
              justifyContent="space-between"
              borderBottomWidth="1px"
              borderBottomColor="#47475F"
              pb="12px"
            >
              <Stack isInline>
                <Box
                  minWidth="120px"
                  as="a"
                  d="block"
                  href="/"
                  aria-label="Dotpay logo |Back to homepage"
                >
                  <Logo color="white" />
                </Box>
                <MainDashboardMenu {...{ currentSection, setCurrentSection }}/>
              </Stack>

              <Stack  mx="20px" alignItems="center" spacing={1} isInline>
                <Box>
                <AddMenu />
                </Box>
                {/* <Box color="primary.100" size="18px" as={FaRegBell} /> */}
                <ProfileMenu {...{merchantDetails}} />
                {/** This is for mobile menu */}
                <IconButton
                  display={["block", "block", "none", "none"]}
                  ref={btnRef}
                  variant="ghost"
                  color="primary.100"
                  aria-label="Mobile menu icon"
                  size="xs"
                  fontSize="20px"
                  mx={2}
                  _hover={{
                    bg:"none",
                    color:"primary.300"
                  }}
                  icon={GiHamburgerMenu}
                  onClick={onOpen}
                />

              </Stack>
            </Flex>
          </Box>
        </Flex>
      </Box>
      <MobileMenu {...{ btnRef, isOpen, onClose, currentSection, setCurrentSection }} />
    </>
  );
};

export default DashboardHeader;
